import React from 'react';

import '../css/search-top-bar.less';

export default class SearchTopBar extends React.Component {

    render() {
        const { className } = this.props;
        return (
            <div className={`search-top-bar${className ? ' ' + className : ''}`}>
             {this.props.children}
            </div>
        );
    }

}

